import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { ElevatorIcon } from "../core/icons/Icons";
import { InputLabel } from "@material-ui/core";

export const ElectricElevatorForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } = useFormModel<
        ChangeNames.NEW_CONNECTION_ELECTRIC_ELEVATOR
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<ElevatorIcon />}
                content={
                    <p className={classes.label} style={{ marginBottom: 24 }}>
                        Aufzugsanlage
                    </p>
                }
                useSwitch={
                    <Switch
                        checked={values.newConnectionElectricElevator.value.installed}
                        {...getFieldProps("newConnectionElectricElevator.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.newConnectionElectricElevator.value.installed = checked;
                                values.newConnectionElectricElevator.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.newConnectionElectricElevator.value.installed}
                detail={
                    <Fragment>
                        <InputLabel
                            className={classes.labledTextfieldLabel}
                            style={{ marginTop: 0 }}
                        >
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.newConnectionElectricElevator.value.demand.precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.newConnectionElectricElevator.value.demand.unit}
                            value={values.newConnectionElectricElevator.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.newConnectionElectricElevator.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.newConnectionElectricElevator.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
